import { Component } from '@angular/core';


@Component({
    selector: 'app-favorites',
    imports: [],
    templateUrl: './favorites.component.html',
    styleUrl: './favorites.component.sass'
})
export class FavoritesComponent {

}
